import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const ProductFamilyEmbeddingsStatus = z.enum([
  "none",
  "running",
  "completed",
  "failed",
]);
export type ProductFamilyEmbeddingsStatus = z.infer<
  typeof ProductFamilyEmbeddingsStatus
>;

export const getProductFamilyEmbeddingsStatus = {
  name: "getProductFamilyEmbeddingsStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    status: ProductFamilyEmbeddingsStatus,
    workflowId: z.string().nullable(),
    startedAt: z.date().nullable(),
    completedAt: z.date().nullable(),
  }),
};
